<template>
  <div class="generator_stop-icon" v-tooltip="buttonTooltip">
    <div
      class="generator_stop-icon-loading"
    />
    <aha-icon
      name="stop-dark"
      class="generator_stop-icon-svg"
      width="16"
      height="16"
      viewBox="0 0 20 20"
    ></aha-icon>
    <div class="generator_stop-background"></div>
  </div>
</template>

<script>
export default {
  props: {
    isSubmitting: {
      type: Boolean,
      default: false,
    },
    isSubmittingFeedback: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      timer: null,
      currentProgress: 0,
      step: 0.15,
      progress: 0,
      firstAngle: 0,
      secondAngle: 0,
    }
  },
  computed: {
    buttonTooltip() {
      return this.$i18nPresenter.t('Stop generating')
    },
  },
}
</script>

<style lang="scss" scope>
.generator_stop-icon {
  position: relative;
  width: 22px;
  height: 22px;
  display: flex;
  align-items: center;
  justify-content: center;
  &:hover {
    .generator_stop-background {
      @apply bg-primary-50 rounded-full absolute opacity-100;
      width: 32px;
      height: 32px;
      left: -5px;
      top: -4px;
      z-index: -1;
}
  }
  .generator_stop-background {
    @apply opacity-0 transition-opacity duration-200;
  }
}
.generator_stop-icon-loading {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border-radius: 50%;
  animation: spin 1s linear infinite;
  border: 2px solid rgba(49, 49, 49, 0.3);
  border-top-color: #313131;
}
.generator_stop-icon-svg {
  position: absolute;
  border-radius: 50%;
  background-color: #ffffff;
}

</style>
